<template>
  <v-flex pa-0 text-xs-left
  class="job-card"
  key="job.id"
  :data-invoice-ref="job.invoice_ref"
  :data-has-invoice="job.hasInvoice || false"
  :data-client="job.clientName || false"
  :data-jobTitle="job.title || false"
  :class="{ fadein, 'search-hide' : searchHide }">
    <v-flex pa-0>
      <div :class='showAlert' class="details clearfix " @click="showTheCard">
        <span  class="ititle" >{{alwaysClientName}}</span>
        <span  class="ijob_description">{{alwaysJobTitle}}</span>
        <transition name="fade">
        <div class="iwrap" >
          <span v-if="displayWithTax"  class="iprice"><strong>Cost:</strong>{{job.amount | toCurrency(lang, currCode) }}</span>
          <span v-else class="iprice"><strong>Cost:</strong>{{job.totalNetAmount | toCurrency(lang, currCode) }}</span>
          <span v-if="job.chase_date && listId === 1" class="ichase_date"><strong>Chase:</strong>{{formatDate(job.chase_date)}}</span>
          <span v-if="job.quoted_date && listId === 1" class="ichase_date"><strong>Quoted:</strong>{{formatDate(job.quoted_date)}}</span>
          <!--<span v-if="job.accepted_date && (listId === 1 || listId === 2 || listId === 3)" class="ichase_date"><strong>Accepted: </strong>{{formatDate(job.accepted_date)}}</span>-->
          <span v-if="job.start_date && listId === 2" class="istart_date"><strong>Start:</strong>{{formatDate(job.start_date)}}</span>
          <span v-if="job.deadline_date && listId === 3" class="ideadline_date"><strong>Finish:</strong>{{formatDate(job.deadline_date)}}</span>
          <span v-if="job.invoiced_date && listId === 4" class="iinvoiced_date"><strong>Invoiced:</strong>{{formatDate(job.invoiced_date)}}</span>
          <span v-if="job.paid_date && listId === 5" class="ipaid_date"><strong>Paid:</strong>{{formatDate(job.paid_date)}}</span>
          <!-- <span v-if="job.invoice_ref " class="block"><strong>Ref:</strong> {{job.invoice_ref}}</span> -->
        </div>
        </transition>
      </div>
    </v-flex>
  </v-flex>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'
import DisplayAmount from '@/components/Shared/DisplayAmount'
import moment from 'moment-timezone'

export default {
  name: 'job',
  mixins: [formatDate],
  props: {
    listId: Number,
    job: Object,
    index: Number
  },
  components: {
    DisplayAmount
  },
  data () {
    return {
      showCard: false,
      fadein: false,
      alertThreshold: this.$store.getters.group.chosenAlertTimeScale,
      latestJobKey: this.$store.getters.latestJobKey, // gets the latest key added so we can open the job up if it;s the newset,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol,
      displayWithTax: this.$store.getters.group.displayWithTax || false
    }
  },
  computed: {
    searchString: function () {
      return this.$store.getters.jobFilter
    },
    searchHide: function () {
      if (this.searchString !== '') {
        // if job.title or job.clientName matches searchString then return searchVisible
        if (
          this.job.title
            .toLowerCase()
            .includes(this.searchString.toLowerCase()) ||
          this.job.clientName
            .toLowerCase()
            .includes(this.searchString.toLowerCase())
        ) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    showAlert: function () {
      let today = new Date()
      let dd = today.getDate()
      let mm = today.getMonth() + 1 // January is 0!
      let yyyy = today.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      if (
        this.listId === 1 &&
        this.job.chase_date !== '' &&
        this.job.chase_date <= today
      ) {
        return 'showAlert'
      } else if (
        this.listId === 2 &&
        this.job.start_date !== '' &&
        this.job.start_date <= today
      ) {
        return 'showAlert'
      } else if (
        this.listId === 3 &&
        this.job.marked !== 'r' &&
        this.job.deadline_date !== '' &&
        this.job.deadline_date <= today
      ) {
        return 'showAlert'
      } else if (
        this.listId === 4 &&
        this.job.invoiced_date !== '' &&
        (moment(this.job.invoiced_date).add(this.alertThreshold, 'days').isBefore(Date.now()))
      ) {
        return 'showAlert'
      } else if (
        this.job.marked === 'r' &&
        this.listId === 4 &&
        this.job.invoiced_date !== '' &&
        (moment(this.job.invoiced_date).add(this.alertThreshold, 'days').isBefore(Date.now()))
      ) {
        return 'showAlert'
      } else if (this.job.marked === 'r') {
        return 'marked'
      }
      return 'noAlert'
    },
    alwaysJobTitle: function () {
      if (this.job.title !== '' && this.job.title !== null) {
        return this.job.title
      } else {
        return 'Untitled Job'
      }
    },
    alwaysClientName: function () {
      if (this.job.clientName !== '' && this.job.clientName !== null) {
        return this.job.clientName
      } else {
        return 'Untitled Client'
      }
    }
  },
  methods: {
    showTheCard () {
      this.$store.commit('setJobDetailModalJob', this.job)
      this.$store.commit('toggleShowJobDetailModal')
    }
  },
  created () {
    // if this is the latest job then open it up for editing
    if (this.job.id === this.latestJobKey) {
      this.showCard = true
      this.fadein = true
      // now clear the flag in the store so we dont do this every time it's moved to another column
      this.$store.commit('setLatestJobKey', null)
    }
  }
}
</script>

<style lang="scss">
.job-card {
  box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.1);
  margin-bottom:11px;

}
.job-card{
  &.search-hide{
    display:none;
  }
}
.details {
  border-radius: 3px;

  padding: 7px 17px 6px 15px;
  cursor: pointer;
  // background:#fff;
  background-image: linear-gradient(to right, var(--green), var(--green)),
    linear-gradient(to right, #ffffff, #ffffff);
  background-repeat: no-repeat;
  background-position: 0 0px, 0 0px;
  background-size: 5px 100%, 100% 100%;
  user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

  &.marked {
    background-image: linear-gradient(to right, var(--yellow), var(--yellow)),
      linear-gradient(to right, #ffffff, #ffffff);
  }
  &.showAlert {
    background-image: linear-gradient(to right, var(--red), var(--red)),
      linear-gradient(to right, #ffffff, #ffffff);
  }
}
.ititle{
  display: block;
  font-weight:700;
  font-size:.95rem;
  .xsOnly &{
    font-size:1.1rem;
  }
}

.ijob_description {
  display: block;
  color: var(--light-text);
  font-size: 0.8rem;
  font-weight:500;
  .xsOnly &{
    font-size:.95rem;
  }
}
.iwrap {
  line-height: 1.2;
  padding-top:1px;
  padding-bottom:2px;
  span {
    // dont wrap text move to next line
    display:inline-block;
    color: var(--light-text);
    font-size: 0.8rem;
    font-weight:700;
    padding-right: 10px;
    .xsOnly &{
      font-size:.95rem;
    }
    &.block{
      display:inline-block;
      strong {
        padding-left:0;
      }
    }
    strong {
      color: var(--dark-text);
      font-weight: 700;
      padding-right:3px;
    }
  }
}
.fadein{
  animation: fadein .8s;
}
@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
</style>
